import styled from "styled-components";

import { Container, Column, Button } from "@ui/Atoms";

export const Root = styled(Container).attrs({ as: "section" })`
  padding-top: 0px;
  padding-bottom: ${({ theme }) => theme.spacing.spacing_32};

  ${props => props.theme.breakpoints.tablet} {
    padding-bottom: ${({ theme }) => theme.spacing.spacing_64};
  }

  ${props => props.theme.breakpoints.desktop} {
    padding-bottom: ${({ theme }) => theme.spacing.spacing_80};
  }
`;

export const Actions = styled(Column).attrs({
  xs: 12,
})`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_32};
  justify-content: center;

  ${props => props.theme.breakpoints.mobile} {
    flex-direction: row;
  }
`;

export const ActionBtn = styled(Button)`
  ${props => props.theme.breakpoints.mobile} {
    min-width: 188px;
    width: fit-content;
  }
`;
